<template>
    <div class="text-left">
        <v-progress-circular
            v-if="loading"
            indeterminate
            size="24"
            width="3"
        ></v-progress-circular>
        <span v-else-if="expanded">
            <v-icon :large="large" :color="statusColor">
                {{ icons.device }}
            </v-icon>
            <v-icon :color="statusColor" small class="icon-suffix">{{
                iconSuffix
            }}</v-icon>
            <span class="pl-1">{{ formattedStatusDate }}</span>
            <v-tooltip top>
                <template v-slot:activator="{ on: refresh }">
                    <v-btn
                        icon
                        :color="buttonColor"
                        v-on="refresh"
                        @click="onIconClick"
                        ><v-icon>mdi-autorenew</v-icon>
                    </v-btn>
                </template>
                <span>Check health status</span>
            </v-tooltip>
        </span>
        <span v-else>
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <v-btn
                        v-if="button"
                        :color="buttonColor"
                        small
                        outlined
                        aria-label="Refresh status"
                        min-width="24"
                        class="px-0"
                        v-on="on"
                        @click="onIconClick"
                    >
                        <v-icon :large="large" :color="statusColor">
                            {{ icons.device }}
                        </v-icon>
                        <v-icon
                            :color="statusColor"
                            small
                            class="icon-suffix"
                            >{{ iconSuffix }}</v-icon
                        >
                    </v-btn>
                    <span v-else v-on="on">
                        <v-icon :large="large" :color="statusColor">
                            {{ icons.device }}
                        </v-icon>
                        <v-icon
                            :color="statusColor"
                            small
                            class="icon-suffix"
                            >{{ iconSuffix }}</v-icon
                        >
                    </span>
                </template>
                <div class="text-caption">
                    <div
                        v-for="(item, index) in statusTooltip"
                        :key="`tooltip-${index}`"
                    >
                        {{ item }}
                    </div>
                </div>
            </v-tooltip>
        </span>
    </div>
</template>

<script>
import statusColors from '@/shared/statusColors';
import { VIcon, VBtn, VTooltip, VProgressCircular } from 'vuetify/lib';

export default {
    name: 'DeviceHealthIcon',
    components: {
        'v-icon': VIcon,
        'v-btn': VBtn,
        'v-tooltip': VTooltip,
        'v-progress-circular': VProgressCircular
    },
    props: {
        value: {
            type: Object,
            required: true
        },
        large: {
            type: Boolean,
            required: false,
            default: false
        },
        loading: {
            type: Boolean,
            required: false,
            default: false
        },
        button: {
            type: Boolean,
            required: false,
            default: false
        },
        tooltip: {
            type: [String, Array],
            required: false,
            default: ''
        },
        buttonColor: {
            type: String,
            default: 'primary'
        },
        expanded: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        iconSuffixMap() {
            return {
                CONNECTED: this.icons.check,
                SERVICE_ERROR: this.icons.close,
                COMMUNICATION_FAIL: this.icons.close
            };
        },
        formattedStatusDate() {
            return this.toLocaleDate(this.value.statusDate);
        },
        statusColor() {
            const colorSet = this.$vuetify.theme.isDark
                ? statusColors.dark
                : statusColors.light;
            if (
                this.value &&
                this.value.status &&
                colorSet[this.value.status]
            ) {
                return colorSet[this.value.status];
            } else {
                return colorSet.default;
            }
        },
        statusTooltip() {
            let result = [];
            result.push(
                `${this.value.status ? this.value.status : 'UNKNOWN'} - ${
                    this.formattedStatusDate
                }`
            );
            if (Array.isArray(this.tooltip) && this.tooltip.length) {
                result.push(...this.tooltip);
            } else if (this.tooltip.length) {
                result.push(this.tooltip);
            }
            return result;
        },
        iconSuffix() {
            if (this.value && this.iconSuffixMap[this.value.status]) {
                return this.iconSuffixMap[this.value.status];
            }
            return this.icons.question;
        }
    },
    methods: {
        onIconClick() {
            this.$emit('click');
        },
        toLocaleDate(value) {
            if (value) {
                return new Date(value).toLocaleString();
            }
            return '';
        }
    }
};
</script>

<style lang="scss" scoped>
.status-icon {
    white-space: nowrap !important;
}
.icon-suffix {
    margin-left: -4px;
}
</style>
